var _style, _g, _g2, _g3, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatus1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 30 30",
    style: {
      enableBackground: "new 0 0 30 30"
    },
    xmlSpace: "preserve",
    width: "30px",
    height: "30px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;stroke:#13120C;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st1{fill:#8DB9E4;}\r\n\t.st2{fill:none;stroke:#13120C;stroke-width:2;stroke-miterlimit:10;}\r\n\t.st3{fill:#FFFFFF;stroke:#008ECF;stroke-width:0.5;stroke-miterlimit:10;}\r\n\t.st4{display:none;}\r\n\t.st5{display:inline;}\r\n\t.st6{fill:#E53929;}\r\n\t.st7{fill:none;stroke:#1D1D1B;stroke-width:2;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Bkg"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M12.6,1.9c2.3-0.5,4.7-0.3,6.9,0.7c2,0.9,3.6,2.5,4.7,4.3c1.1,1.9,1.5,4.1,1.3,6.2c-0.2,1.8-1.1,3.5-2.1,5.1 c-0.9,1.4-2,2.6-3,3.8c-1.8,2.1-3.6,4.2-5.4,6.3c-2.1-2.2-4.1-4.4-6.1-6.7c-1.3-1.5-2.6-3.1-3.4-5c-0.9-1.9-1.2-4-0.9-6 c0.3-2.2,1.3-4.2,2.8-5.8C8.8,3.4,10.6,2.3,12.6,1.9"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Livello_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "98.8,10.5 107.1,0.4 109.1,-3.5 109.1,-7.8 108.3,-7.9 88.8,-8 88.4,-7.2 88.9,-3.2 90.6,1.9  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M96.2-15.9c2.3-0.5,4.7-0.3,6.9,0.7c2,0.9,3.6,2.5,4.7,4.3c1.1,1.9,1.5,4.1,1.3,6.2c-0.2,1.8-1.1,3.5-2.1,5.1 c-0.9,1.4-2,2.6-3,3.8c-1.8,2.1-3.6,4.2-5.4,6.3c-2.1-2.2-4.1-4.4-6.1-6.7c-1.3-1.5-2.6-3.1-3.4-5c-0.9-1.9-1.2-4-0.9-6 c0.3-2.2,1.3-4.2,2.8-5.8C92.4-14.4,94.2-15.4,96.2-15.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "98.7,-12.5 93.5,-2.8 98.3,-2.8 97.1,4 102.7,-5.4 97.5,-5.6  "
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Giallo"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "5.5,16.7 24.4,16.7 15.3,28  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M12.6,1.9c2.3-0.5,4.7-0.3,6.9,0.7c2,0.9,3.6,2.5,4.7,4.3c1.1,1.9,1.5,4.1,1.3,6.2c-0.2,1.8-1.1,3.5-2.1,5.1 c-0.9,1.4-2,2.6-3,3.8c-1.8,2.1-3.6,4.2-5.4,6.3c-2.1-2.2-4.1-4.4-6.1-6.7c-1.3-1.5-2.6-3.1-3.4-5c-0.9-1.9-1.2-4-0.9-6 c0.3-2.2,1.3-4.2,2.8-5.8C8.8,3.4,10.6,2.3,12.6,1.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "15.3,5.6 10.1,15.3 14.9,15.3 13.8,22.1 19.4,12.7 14.2,12.5  "
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Rosso",
    className: "st4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "st5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "15.1,27.5 19.2,22.8 10.9,23  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st7",
    d: "M12.6,1.9c2.3-0.5,4.7-0.3,6.9,0.7c2,0.9,3.6,2.5,4.7,4.3c1.1,1.9,1.5,4.1,1.3,6.2c-0.2,1.8-1.1,3.5-2.1,5.1 c-0.9,1.4-2,2.6-3,3.8c-1.8,2.1-3.6,4.2-5.4,6.3c-2.1-2.2-4.1-4.4-6.1-6.7c-1.3-1.5-2.6-3.1-3.4-5c-0.9-1.9-1.2-4-0.9-6 c0.3-2.2,1.3-4.2,2.8-5.8C8.8,3.4,10.6,2.3,12.6,1.9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus1);
export default __webpack_public_path__ + "static/media/status_1.09dc7cdcc4f72ec5b3154520ded29a68.svg";
export { ForwardRef as ReactComponent };